import { MainColor } from '../../palette';

export const getPricingFormTheme = () => {
  return {
    entries: {
      border: 'coolGrey20' satisfies MainColor as MainColor,
      readonly: {
        text: 'coolGrey70' satisfies MainColor as MainColor,
      },
    },
  };
};

export type PricingFormTheme = ReturnType<typeof getPricingFormTheme>;
